// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_card__YQTW7 {
  height: 25vh;
  width: 90%; }

.styles_feedContainer__2i1lu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; }
  .styles_feedContainer__2i1lu > div {
    width: 90%; }

.styles_contentCard__TjD5T {
  height: 72vh;
  width: 90%; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/submodules/trackedTime/components/screens/TrackedTimeScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,UAAU,EAAA;;AAGd;EAEI,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAA;EAL3B;IAOQ,UAAU,EAAA;;AAIlB;EACI,YAAY;EACZ,UAAU,EAAA","sourcesContent":[".card {\n    height: 25vh;\n    width: 90%;\n}\n\n.feedContainer {\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    & > div {\n        width: 90%;\n    }\n}\n\n.contentCard {\n    height: 72vh;\n    width: 90%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `styles_card__YQTW7`,
	"feedContainer": `styles_feedContainer__2i1lu`,
	"contentCard": `styles_contentCard__TjD5T`
};
export default ___CSS_LOADER_EXPORT___;
